{
  "manager": {
    "tableCurrentlyIn": {
      "scanOut": "Scan Out"
    },
    "scanHistory": {
      "title": "Scan History",
      "scanInOut": "Scan In/Out",
      "stillIn": "Still in"
    },
    "scanIndex": {
      "title": "Scan In/Out",
      "viewHistory": "View History",
      "scanPlaceholder": "Scan barcode or enter User ID / Member ID",
      "scanning": "Scanning...",
      "scan": "Scan",
      "scannedIn": "scanned in",
      "scannedOut": "scanned out",
      "usePhoneScanner": "Use your phone as a camera scanner",
      "hideQrCode": "Hide QR code",
      "showQrCode": "Show QR code",
      "qrCodeAlt": "Mobile Scanner QR Code",
      "qrCodeInstructions": "Scan this QR code with your phone to open a camera-based scanner.",
      "generating": "Generating...",
      "currentlyIn": "Currently In",
      "noneScannedIn": "No one currently scanned in.",
      "todaysActivity": "Today's Activity",
      "noActivityToday": "No activity today."
    },
    "mobileScanner": {
      "retryCamera": "Retry Camera",
      "scannedIn": "scanned in",
      "scannedOut": "scanned out",
      "identifierPlaceholder": "Enter User ID or Member ID",
      "scanning": "Scanning...",
      "scan": "Scan",
      "recentScans": "Recent Scans",
      "badgeIn": "In",
      "badgeOut": "Out"
    }
  }
}
